import React, { createContext, useCallback, useContext, useState } from "react";

export const OverviewDashboardContext = createContext();

export const OverviewDashboardContextProvider = ({ children }) => {
  const [loadedWidgetsTracker, setLoadedWidgetsTracker] = useState([]);
  const [emptyWidgetIds, setEmptyWidgetIds] = useState(new Set());
  const [trackerResetKey, setTrackerResetKey] = useState(0);

  const reportWidgetDataStatus = useCallback((widgetId, hasData) => {
    setEmptyWidgetIds(prev => {
      if (!hasData) {
        if (prev.has(widgetId)) return prev;
        const next = new Set(prev);
        next.add(widgetId);
        return next;
      } else {
        if (!prev.has(widgetId)) return prev;
        const next = new Set(prev);
        next.delete(widgetId);
        return next;
      }
    });
  }, []);

  return (
    <OverviewDashboardContext.Provider
      value={{
        loadedWidgetsTracker,
        setLoadedWidgetsTracker,
        emptyWidgetIds,
        setEmptyWidgetIds,
        reportWidgetDataStatus,
        trackerResetKey,
        setTrackerResetKey,
      }}
    >
      {children}
    </OverviewDashboardContext.Provider>
  );
};

export const useOverviewDashboardContext = () => {
  return useContext(OverviewDashboardContext);
};